import React, { useContext, useMemo } from 'react';
import { LanguageContext } from '../../../../../../../libs/Context';
import { Box, Grid, Stack, Tooltip, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { FaRegClock } from 'react-icons/fa';
import { GrGroup } from 'react-icons/gr';
import { RiLock2Line } from 'react-icons/ri';
import { SlCamrecorder } from 'react-icons/sl';
import { calculateDuration, capitalizeFirstLetter, formatTimeAMPM, userFullName } from '../../../../../../../libs/HelperContent';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import ProfilePic from '../../../../../../../components/Common/ProfilePic';
import Attachment from '../../../../../../../components/Common/Attachments';
import AttendeesList from './AttendeesList';

const DetailTopLeft = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { form } = props;
	const userData = useSelector((state:any) => state.mysession.session);

	const renderDetailItem = (icon, title, content) => (
		<Grid container pb='var(--pixel16)' alignItems='center'>
			<Grid item>
				<Tooltip title={title} placement='right'>
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--grayF3)', borderRadius: 'var(--pixel4)', textAlign: 'center', fontWeight: '500', width: 'var(--pixel40)', height: 'var(--pixel40)' }}>
						{icon}
					</Box>
				</Tooltip>
			</Grid>
			<Grid item>
				<Typography variant='inherit' sx={{ paddingLeft: 'var(--pixel4)' }}>
					{content}
				</Typography>
			</Grid>
		</Grid>
	);

	const GetScheduleTime = useMemo(() =>
	{
		const formattedDate = form?.timeZone
			? moment(form?.startTimeUTC).tz(form?.timeZone)
				.format('MMMM D, YYYY')
			: '';

		return formattedDate;
	}, [ form?.timeZone, form?.startTimeUTC ]);

	return (
		<>
			<Grid container>
				<Stack direction='row' width='var(--percent100)' alignItems='center' pb='var(--pixel16)'>
					<Tooltip title='Webinar date' placement='right'>
						<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--grayF3)', borderRadius: 'var(--pixel4)', textAlign: 'center', fontWeight: '500', width: 'var(--pixel40)', height: 'var(--pixel40)' }}>
							<MdOutlineCalendarMonth />
						</Box>
					</Tooltip>
					<Stack direction={'row'} pl='var(--pixel8)' alignItems={'baseline'}>
						{GetScheduleTime}
					</Stack>
				</Stack>
				<Stack direction='row' width='var(--percent100)' alignItems='center' pb='var(--pixel16)'>
					<Stack>
						<Tooltip title='Webinar Time 'placement='right'>
							<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--grayF3)', borderRadius: 'var(--pixel4)', textAlign: 'center', fontWeight: '500', width: 'var(--pixel40)', height: 'var(--pixel40)' }}>
								<FaRegClock />
							</Box>
						</Tooltip>
					</Stack>
					<Stack direction={'row'} pl='var(--pixel8)'>
						<Typography>{`${formatTimeAMPM(form?.startTimeUTC)} to ${formatTimeAMPM(form?.endTimeUTC)}`}</Typography>
						<Typography>&nbsp;-&nbsp;</Typography>
						<Typography>{form?.duration ? calculateDuration(form?.startTimeUTC, form?.endTimeUTC) : ''}</Typography>
					</Stack>
				</Stack>
				{renderDetailItem(
					<img src='/images/icons/meetPerson.svg' alt='person' width='20px' height='20px' />, language.host, (
						<Stack direction='row' alignItems='center'>
							<div className='flexAutoRow'>
								<div className='imgAvatarSM brdrRadius50 brdrBlackSM avatarBgColor'>
									<ProfilePic
										imagePath={`${userData?.userId}.jpeg`}
										defaultImg={undefined}
										alt={''}
										width='auto'
										className='imgAvatarSM brdrBlackSM brdrRadius50'
										from='selfProfile'
									/>
								</div>
							</div>
							<Stack direction={'column'} pl='var(--pixel8)'>
								<Typography variant='inherit'>
									{capitalizeFirstLetter(userFullName(userData))}
								</Typography>
								<Typography fontSize={'var(--pixel12)'} color={'var(--txtColorBlackL)'}>{language?.host}</Typography>
							</Stack>
						</Stack>
					))}
				{(form?.metaData?.externalMembers?.length > 0 ||
				form?.metaData?.relations?.length > 0) &&
			renderDetailItem(<GrGroup />, language.participants, (
				<AttendeesList
					form={form}
				/>
			))}
				<>
					{/* // renderIconWithText(<SlCamrecorder />, 'Password')) */}
					{renderDetailItem(<RiLock2Line />, language.password,
						<Typography display='flex' alignItems='center' variant='inherit'>
							Password
							{form?.meetingPassword
								? <CheckCircle fontSize='small' sx={{ marginLeft: 'var(--pixel8)', color: 'var(--meetLive)' }} />
								: <CancelIcon fontSize='small' sx={{ marginLeft: 'var(--pixel8)', color: 'var(--dangerColor)' }} />}
						</Typography>
					)}
					{renderDetailItem(<SlCamrecorder />, language.cloud_recording,
						// renderIconWithText(<SlCamrecorder />, language.cloud_recording)
						<Typography display='flex' alignItems='center' variant='inherit'>
							Cloud Recording
							{form?.recording
								? <CheckCircle fontSize='small' sx={{ marginLeft: 'var(--pixel8)', color: 'var(--meetLive)' }} />
								: <CancelIcon fontSize='small' sx={{ marginLeft: 'var(--pixel8)', color: 'var(--dangerColor)' }} />}
						</Typography>
					)
					}
				</>
			</Grid>
			{/* <Grid container direction={'row'} pb='var(--pixel8)'
			alignItems={'center'} justifyContent={'space-between'}>
				<Grid item p='var(--pixel8)'>
					<Typography fontWeight='var(--font500)' 
					color={'textSecondary'}>{language?.attachments} (5)</Typography>
				</Grid>
				<Grid item>
					<Typography
						fontWeight='var(--font500)'
						color={'var(--primaryColor)'}
						pb='var(--pixel8)'
						variant='body2'
						onClick={handleToggleAttachments}
						style={{ cursor: 'pointer' }}
					>
						{showMoreAttachments ? `${language?.viewless}` : `${language?.viewmore}`}
					</Typography>
				</Grid>
			</Grid> */}

			<Grid container>
				<Attachment
					attachments={form?.attachments}
				/>
			</Grid>
		</>
	);
};

export default DetailTopLeft;
